import { render } from "./SemesterTestsPage.vue?vue&type=template&id=21f98848&scoped=true"
import script from "./SemesterTestsPage.vue?vue&type=script&lang=js"
export * from "./SemesterTestsPage.vue?vue&type=script&lang=js"

import "./SemesterTestsPage.vue?vue&type=style&index=0&id=21f98848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f98848"]])

export default __exports__